import { gql } from '@apollo/client';

export const FETCH_CREW_MEMBER_GROUPS = gql`
	query crewMemberGroups {
		crewMemberGroups {
			id
			name
		}
	}
`;
